import React from 'react';
import Input from '../../../../components/input/Input';
import { getDifferenceList } from '../../../../lib/common';
import CheckBox from '../../../../components/input/CheckBox';
import Button from '../../../../components/Button';
import './BrandExposureSelectorHeader.scss';

const BrandExposureSelectorHeader = (props) => {
  const {
    brandExposureList,
    brandExposureSelector,
    setData,
    searchBrandExposureSelectorList,
    resetBrandExposureSelectorList,
    addSelectedItemToList,
  } = props;
  const { newList } = brandExposureList;
  const { list, filterOption, selectedList } = brandExposureSelector;
  const { isSearch, storeName } = filterOption;
  const { inActive, active } = isSearch;

  return (
    <div className="brand-exposure-selector-header">
      {/*브랜드 노출 여부 선택*/}
      <div className="selector-check-section">
        <CheckBox
          text="노출되고 있지 않은 매장"
          checked={inActive}
          onChange={(checked) => {
            setData({
              path: ['brandExposureSelector', 'filterOption', 'isSearch', 'inActive'],
              value: checked,
            });
          }}
        />

        <CheckBox
          text="노출되고 있는 매장"
          checked={active}
          onChange={(checked) => {
            setData({
              path: ['brandExposureSelector', 'filterOption', 'isSearch', 'active'],
              value: checked,
            });
          }}
        />
      </div>

      {/*브랜드 검색*/}
      <div className="selector-search-section">
        <Input
          size={'large'}
          placeholder={'브랜드명을 입력하세요'}
          onChange={(value) => {
            setData({
              path: ['brandExposureSelector', 'filterOption', 'storeName'],
              value,
            });
          }}
          value={storeName}
        />

        <Button color="primary" text="검색" onClick={searchBrandExposureSelectorList} />

        <Button color="light" text="초기화" onClick={resetBrandExposureSelectorList} />
      </div>

      {/*전체선택/해제 버튼 및 선택 추가*/}
      <div className="selector-select-section">
        <div className="selector-select-all-check-wrap">
          <Button
            color="primary"
            text="전체선택"
            onClick={() => {
              setData({
                path: ['brandExposureSelector', 'selectedList'],
                value: getDifferenceList(list, newList, 'storeId', 'storeId'),
              });
            }}
          />

          <Button
            color="gray"
            text="전체해제"
            onClick={() => {
              setData({
                path: ['brandExposureSelector', 'selectedList'],
                value: [],
              });
            }}
          />
        </div>

        <Button
          color="primary"
          text="선택추가"
          disabled={!selectedList.length}
          onClick={() => addSelectedItemToList()}
        />
      </div>
    </div>
  );
};

export default BrandExposureSelectorHeader;
